/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestComponent {
    getFixupPrototypeFunction() { return ServiceNowRequestComponent.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestComponent>): ServiceNowRequestComponent {
        let obj = Object.assign(new ServiceNowRequestComponent(), model);
        ServiceNowRequestComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestComponent>): ServiceNowRequestComponent {
        if (!model) return null;
        return ServiceNowRequestComponent.newInstance(<ServiceNowRequestComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestComponent) {
        if (!obj) return;

        models.ServiceNowRequestComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestComponent): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Sys Id of the ServiceNow Component
     */
    sys_id: string;

    /**
     * Title of the ServiceNow Component
     */
    title: string;

}
